import { Injectable } from '@angular/core';

@Injectable()
export class TermsConditionService {

   AUTH_URL: string = '';
   environmentName: string = '';
   JLL_DOMAIN: string = '';
   featureObject: any = {};

   constructor() { }

   // JLL
  isJLLSite() {
    return (<any>window).location.hostname === this.JLL_DOMAIN;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/terms-condition/terms-condition.service.ts